export const SET_STATE = "setState";
export const SET_BUSINESS = "setBusiness";
